import React from "react";
import { Box, Typography, useTheme, useMediaQuery } from "@mui/material";
import BuildIcon from "@mui/icons-material/Build";

const WorkInProgress = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "80vh",
        backgroundColor: "#000",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        textAlign: "center",
        px: isMobile ? 2 : 3,
      }}
    >
      {/* Icon */}
      <Box sx={{ mb: isMobile ? 3 : 4, color: "#00BCD4" }}>
        <BuildIcon sx={{ fontSize: isMobile ? 60 : 80 }} />
      </Box>

      {/* Heading */}
      <Typography
        variant={isMobile ? "h4" : "h3"}
        sx={{
          color: "#fff",
          fontWeight: "bold",
          letterSpacing: 2,
          mb: isMobile ? 3 : 4,
        }}
      >
        WORK IN PROGRESS
      </Typography>

      {/* Animated Loading Bar */}
      <Box
        sx={{
          width: isMobile ? "90%" : { xs: "80%", md: "50%" },
          height: isMobile ? 10 : 12,
          borderRadius: 6,
          overflow: "hidden",
          backgroundColor: "rgba(255,255,255,0.1)",
          position: "relative",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: "-50%",
            width: "50%",
            height: "100%",
            background: "linear-gradient(90deg, #2196F3, #00BCD4, #2196F3)",
            animation: "slide 2s linear infinite",
            "@keyframes slide": {
              "0%": { left: "-50%" },
              "100%": { left: "100%" },
            },
          }}
        />
      </Box>

      {/* Text below */}
      <Typography
        variant="body2"
        sx={{ mt: 2, color: "#ccc", fontWeight: 500, fontSize: isMobile ? "0.9rem" : "1rem" }}
      >
        loading.......
      </Typography>
    </Box>
  );
};

export default WorkInProgress;
